<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">Library</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a href="javascript:void(0);">Library</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-institute gallery-sec ptb--100">
  <div class="container">
    <div class="row justify-content-center align-items-center">
      <div class="col-12 text-center">
        <div class="demo-gallery pt-40 mt-4">
          <ul  appLightgallery>
            <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library1.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library1.webp">
              <a href="#">
                <img class="img-responsive" src="{{baseUrl}}/labs/library1.webp" alt=" Library | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Library</h6>
                  <div class="line"></div>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library2.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library2.webp">
              <a href="#">
                <img class="img-responsive" src="{{baseUrl}}/labs/library2.webp" alt=" Library | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Library</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library3.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library3.webp">
              <a href="#">
                <img class="img-responsive" src="{{baseUrl}}/labs/library3.webp" alt=" Library | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Library</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
            <li data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library4.webp"
              data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/labs/library4.webp">
              <a href="#">
                <img class="img-responsive" src="{{baseUrl}}/labs/library4.webp" alt=" Library | GHRCACS, PUNE">
                <div class="demo-gallery-poster">
                  <h6>Library</h6>
                  <i class="fa fa-search-plus"></i>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
